import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const itemChangePoints = "api/truckingBids";

const list = (params: {}) =>
    request(`${itemChangePoints}/getItemChangePointAddresses${containsQuery(params)}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });
    return request(
        `${itemChangePoints}/getItemChangePointAddresses${query}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const apply = (params: {}) => alertRequest(`${itemChangePoints}/applyItemChangePointAddress`, body(params));

const getItem = ({ id }: { id: string }) => {
    return request(`${itemChangePoints}/getItemChangePointAddress/${id}`, { method: "GET" });
};

const delItem = (params: {}) => alertRequest(`${itemChangePoints}/deleteItemChangePointAddress`, body(params));

const restore = (params: {}) => alertRequest(`${itemChangePoints}/restoreItemChangePointAddress`, body(params));

export { list, apply, index, getItem, delItem, restore };
